// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3I_ii","delete":"styles_delete__2n9b_","update":"styles_update__2MGM5","add":"styles_add__37FVF"};